import { SiteHeader } from "./components/SiteHeader.js";

// Shown instead of the app to someone who signed in but isn't on the Ask HR access list: Entra
// refused the sign-in because the account isn't assigned to the app (AADSTS50105), or the account
// has no Ask HR role. The same wording as sites.novara.com's No access page, and the same next
// step. Signing out lets them try another account.
export function NoAccess({ email, onSignOut }: { email?: string; onSignOut: () => void }) {
  return (
    <>
      <SiteHeader title="Ask HR" />
      <main className="wrap">
        <section className="panel no-access">
          <h2>You don't have access to Ask HR</h2>
          <p>
            Ask HR is open to Novara employees. The account you signed in with
            {email ? (
              <>
                {" "}
                (<b>{email}</b>)
              </>
            ) : null}{" "}
            isn't on the access list.
          </p>
          <p>If you think you should have access, raise a request in the IT Help Desk (HELP).</p>
          <p>
            <button type="button" className="primary" onClick={onSignOut}>
              Sign out and try another account
            </button>
          </p>
        </section>
      </main>
    </>
  );
}

// Does this sign-in failure mean "not on the access list"? Entra answers an account that isn't
// assigned to an "assignment required" app with AADSTS50105, and MSAL surfaces it as an
// access_denied error from the redirect. Anything else gets the generic "Couldn't sign you in".
export function isNoAccessError(e: unknown): boolean {
  const err = e as { errorCode?: unknown; errorMessage?: unknown; message?: unknown } | null;
  if (!err || typeof err !== "object") return false;
  const text = `${String(err.errorMessage ?? "")} ${String(err.message ?? "")}`;
  return /AADSTS50105\b/.test(text) || (err.errorCode === "access_denied" && /AADSTS50105|not (been )?assigned|assigned to a role/i.test(text));
}
